<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2.11328 4.96008L7.99994 8.36674L13.8466 4.98006"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 14.4068V8.36011"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.6204 1.65337L3.0604 3.6334C2.25374 4.08006 1.59375 5.20005 1.59375 6.12005V9.88673C1.59375 10.8067 2.25374 11.9267 3.0604 12.3734L6.6204 14.3534C7.3804 14.7734 8.62706 14.7734 9.38706 14.3534L12.9471 12.3734C13.7537 11.9267 14.4137 10.8067 14.4137 9.88673V6.12005C14.4137 5.20005 13.7537 4.08006 12.9471 3.6334L9.38706 1.65337C8.6204 1.22671 7.3804 1.22671 6.6204 1.65337Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.3335 8.82662V6.38664L5.00684 2.73328"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "warehouse-icon",
};
</script>

<style lang="scss" scoped></style>
